(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("sortablejs"));
	else if(typeof define === 'function' && define.amd)
		define([, "sortablejs"], factory);
	else if(typeof exports === 'object')
		exports["vuedraggable"] = factory(require("vue"), require("sortablejs"));
	else
		root["vuedraggable"] = factory(root["Vue"], root["Sortable"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_a352__) {
return 